import React from 'react';
import styled from 'styled-components';
import '../Band/Band.css';
import { FILE } from '../../utils/constants/pdf';

const MainWrapper = styled.div`
  height: 92vh;
  width: 100%;

  h3 {
    margin-top: 40px;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  li {
    margin-bottom: 5px
  }
`;

const AreaB = () => {
  return (
    <MainWrapper>
      <div className="component_img" />
      <h3>Area J 6A Marching Contest information</h3>

      <li className="band-link home-info">
        <a 
          href={FILE.areaJDrawOrder}
          target="blank"
        >
          2026 Area J 6A Prelims Draw Order
        </a>
      </li>
      <li className="band-link home-info">
        <a 
          href={FILE.areaJSchedule}
          target="blank"
        >
          2026 Area J 6A Schedule
        </a>
      </li>
      <li className="band-link home-info">
        <a 
          href="https://drive.google.com/drive/folders/1Dbat_L4a8lOeB0NhsEs8ZS9CieOpKLru?usp=sharing"
          target="blank"
        >
          2026 Area J 6A Directors Information
        </a>
      </li>
      {/* <li className="band-link home-info">
        <a 
        href={FILE.areaJ2025}
          target="blank"
        >
          Area J 6A Prelims Draw Order
        </a>
      </li> */}
    </MainWrapper>
  );
};

export default AreaB;



// WEBPACK FOOTER //
// ./src/Components/AreaB/AreaJ.js